import PropTypes from 'prop-types';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken, isAuthenticated } from '~/services/authentication';

const getUserLevel = () => {
  const token = getToken();

  if (!token) {
    return null;
  }

  const { level } = token;

  return level;
};

const getUserPermissions = () => {
  const token = getToken();

  if (!token) return null;

  const { _roles: roles } = token;

  return roles;
};

const checkModuleAccess = (moduleName) => {
  const userRoles = getUserPermissions();

  if (!userRoles) {
    return false;
  }

  const moduleRole = userRoles.find(role => role.module_name === moduleName);

  if (!moduleRole) {
    return false;
  }
  return moduleRole.role_value;
};

const PrivateRoute = ({
  component: Component,
  userAccessLevel,
  requiredModule,
  ...rest
}) => {
  const userLevel = getUserLevel();

  const hasRoleAccess = () => {
    if (!userAccessLevel) {
      return true;
    }

    if (!userLevel) {
      return false;
    }

    return userAccessLevel.includes(userLevel);
  };

  const hasModuleAccess = () => {
    if (!requiredModule) {
      return true;
    }

    return checkModuleAccess(requiredModule);
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }

        if (!hasRoleAccess()) {
          return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
        }

        if (!hasModuleAccess()) {
          return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
        }

        return (
          <>
            <Component {...props} />
          </>
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  userAccessLevel: PropTypes.arrayOf(PropTypes.number),
  requiredModule: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

PrivateRoute.defaultProps = {
  userAccessLevel: null,
  requiredModule: null,
  location: null,
};

export default PrivateRoute;
